import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import api from '../utils/api';
import toast from 'react-hot-toast';

const PH = 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=300&q=60';
const resolveImg = ph => !ph ? PH : ph.startsWith('http') ? ph : `https://shop.demo.example.com/${ph.replace(/^\/+/,'')}`;

export default function WishlistPage() {
  const { user } = useAuth();
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (user) api.get('/wishlist').then(r => setItems(r.data||[])).catch(()=>{}).finally(()=>setLoading(false));
    else setLoading(false);
  }, [user]);
  const remove = async productId => { await api.delete(`/wishlist/${productId}`); setItems(items.filter(i=>i.product_id!==productId)); toast.success('Removed from wishlist'); };
  const moveToCart = async item => { try { await addToCart(item.product_id,1); await remove(item.product_id); toast.success('Moved to cart! 🛒'); } catch (err) { toast.error(err.message); } };
  if (!user) return <div className="page" style={{textAlign:'center',paddingTop:120}}><Link to="/login" className="btn btn-primary">Login to view wishlist</Link></div>;
  if (loading) return <div className="page"><div className="spinner"/></div>;
  return (
    <div className="page">
      <div className="container" style={{padding:'48px 24px'}}>
        <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:32,color:'#7c3aed',fontStyle:'italic',marginBottom:32}}>My Wishlist {items.length>0 && <span style={{fontSize:20,color:'#64748b'}}>({items.length})</span>}</h1>
        {items.length===0 ? (
          <div style={{textAlign:'center',padding:'64px 0'}}>
            <div style={{fontSize:56}}>❤️</div>
            <h3 style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:'#7c3aed',fontStyle:'italic',margin:'12px 0 8px'}}>Wishlist is empty</h3>
            <p style={{color:'#64748b',marginBottom:20}}>Save your favourite sarees here</p>
            <Link to="/collections" className="btn btn-primary">Browse Collections</Link>
          </div>
        ) : (
          <div className="grid-4">
            {items.map(item => (
              <div key={item.id} style={{border:'1px solid var(--border)',background:'#fff',overflow:'hidden'}}>
                <div style={{position:'relative',aspectRatio:'3/4',background:'#f6efff',cursor:'pointer'}} onClick={()=>navigate(`/product/${item.slug}`)}>
                  <img src={resolveImg(item.photo)} alt={item.name} style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>{e.target.src=PH;}}/>
                  <button onClick={e=>{e.stopPropagation();remove(item.product_id);}} style={{position:'absolute',top:12,right:12,background:'#fff',border:'none',borderRadius:'50%',width:36,height:36,cursor:'pointer',fontSize:16,display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 2px 8px rgba(0,0,0,0.12)'}}>✕</button>
                </div>
                <div style={{padding:16}}>
                  <Link to={`/product/${item.slug}`} style={{fontFamily:"'Cormorant Garamond',serif",fontSize:17,color:'#1a0f0f',textDecoration:'none',display:'block',marginBottom:6,lineHeight:1.3}}>{item.name}</Link>
                  <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:20,color:'#7c3aed',fontWeight:600,marginBottom:12}}>₹{(item.selling_price*(1-(item.discount_pct||0)/100)).toLocaleString('en-IN',{maximumFractionDigits:0})}</div>
                  {item.stock_qty>0 ? <button onClick={()=>moveToCart(item)} className="btn btn-primary" style={{width:'100%',justifyContent:'center',padding:'10px',fontSize:11}}>Move to Cart</button> : <div style={{textAlign:'center',fontSize:13,color:'#999',padding:'10px 0'}}>Out of Stock</div>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
